import React, { useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { MdOutlineLock } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { changePassword } from "redux/actions";

const Changepassword = ({ close }) => {
    const [password, setPassword] = useState({
        newPassword: "",
        confirmPassword: "",
    });
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState({
        newPassword: false,
        confirmPassword: false
    });
    const [errors, setErrors] = useState({
        match: false,
        minLength: false
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPassword(prev => ({ ...prev, [name]: value }));

        // Validate password length
        if (name === "newPassword") {
            setErrors(prev => ({
                ...prev,
                minLength: value.length < 8
            }));
        }

        // Validate password match
        if (name === "confirmPassword" || (name === "newPassword" && password.confirmPassword)) {
            setErrors(prev => ({
                ...prev,
                match: name === "newPassword"
                    ? value !== password.confirmPassword
                    : value !== password.newPassword
            }));
        }
    };

    const toggleShow = (field) => {
        setShow(prev => ({ ...prev, [field]: !prev[field] }));
    };

    const handleChangePassword = async () => {
        // Check for errors before submitting
        if (errors.minLength) {
            toast.error("Password must be at least 8 characters long");
            return;
        }

        if (errors.match) {
            toast.error("Passwords do not match");
            return;
        }

        if (!password.newPassword || !password.confirmPassword) {
            toast.error("Please fill in all fields");
            return;
        }

        try {
            setLoading(true);
            let finalPayload = {
                "verificationToken": token,
                "password": password.confirmPassword,
                "deviceType": "WEB",
                "deviceId": "RTYUJGYUJNHYUIKMUIK"
            };
            let data = await changePassword(finalPayload);
            if (!data.success) throw new Error(data?.message);
            toast.success(data?.message);
            window.location.href = "/login";
            if (close) close();
        } catch (err) {
            toast.error(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="h-screen w-full flex items-center justify-center z-50 px-2">
            <div className="lg:w-[30%] md:w-[55%] sm:w-[85%] w-full h-[60vh] rounded shadow bg-white border flex flex-col items-center justify-center gap-6 p-4 relative">
                <div className="flex flex-col items-center justify-center gap-3 w-full">
                    <div className="w-full flex items-center justify-center flex-col mb-6">
                        <h1 className="text-2xl font-semibold mb-2 uppercase">Change Password</h1>
                        <p className="text-center text-gray-500 text-sm">Enter a new Password below to Change your Password</p>
                    </div>
                    <div className="w-full mb-3 space-y-2">
                        <label className="">New Password</label>
                        <div className="border px-2 py-1 flex bg-white items-center">
                            <MdOutlineLock className="text-xl text-gray-600" />
                            <input
                                type={show.newPassword ? "text" : "password"}
                                value={password.newPassword}
                                name="newPassword"
                                onChange={handleChange}
                                maxLength="100"
                                placeholder="Enter new Password (min 8 characters)"
                                autoComplete="off"
                                className="w-full border-none text-sm bg-transparent text-gray-600"
                            />
                            {show.newPassword ? (
                                <FaRegEye
                                    className="cursor-pointer text-xl text-[#00000081]"
                                    onClick={() => toggleShow("newPassword")}
                                />
                            ) : (
                                <FaRegEyeSlash
                                    className="cursor-pointer text-xl text-[#00000081]"
                                    onClick={() => toggleShow("newPassword")}
                                />
                            )}
                        </div>
                        {errors.minLength && (
                            <p className="text-red-500 text-xs">Password must be at least 8 characters long</p>
                        )}
                    </div>
                    <div className="w-full mb-3 space-y-2">
                        <label className="">Confirm Password</label>
                        <div className="border px-2 py-1 flex bg-white items-center">
                            <MdOutlineLock className="text-xl text-gray-600" />
                            <input
                                type={show.confirmPassword ? "text" : "password"}
                                value={password.confirmPassword}
                                name="confirmPassword"
                                onChange={handleChange}
                                maxLength="100"
                                placeholder="Confirm New Password"
                                autoComplete="off"
                                className="w-full border-none text-sm bg-transparent text-gray-600"
                            />
                            {show.confirmPassword ? (
                                <FaRegEye
                                    className="cursor-pointer text-xl text-[#00000081]"
                                    onClick={() => toggleShow("confirmPassword")}
                                />
                            ) : (
                                <FaRegEyeSlash
                                    className="cursor-pointer text-xl text-[#00000081]"
                                    onClick={() => toggleShow("confirmPassword")}
                                />
                            )}
                        </div>
                        {errors.match && (
                            <p className="text-red-500 text-xs">Passwords do not match</p>
                        )}
                    </div>
                    <button
                        onClick={handleChangePassword}
                        disabled={loading || errors.match || errors.minLength}
                        className={`outline-none p-2 w-full border-none bg-black text-white flex items-center justify-center ${(loading || errors.match || errors.minLength) ? "opacity-50 cursor-not-allowed" : ""
                            }`}
                    >
                        {loading ? "Wait..." : "Change Password"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Changepassword;